<template>
  <div class="main-container">
    <div v-if="loading" class="col-span-full flex justify-center items-center py-20">
      <p class="text-2xl text-gray-500">Yükleniyor...</p>
    </div>

    <div v-else-if="subfolders.length === 0" class="col-span-full flex justify-center items-center py-20">
      <p class="text-2xl text-gray-500">Bu şirket için klasör bulunamadı.</p>
    </div>

    <template v-else>
        <div class="grid grid-cols-12 col-start-1 col-end-13 gap-4">
            <inner-navigation
            v-for="subfolder in subfolders"
            :key="subfolder"
            class="col-span-3"
            :link="`/new-documents/folder?company=${company}&subfolder=${encodeURIComponent(subfolder)}`"
            :title="subfolder"
            :imgURL="companyLogo"
            navStyle="2"
            ></inner-navigation>
        </div>
        </template>
  </div>
</template>

<script>
import firebase from "../../firebase"
import InnerNavigation from "../InnerNavigation.vue"

export default {
  name: 'NewDocumentsMain',
  
  components: {
    InnerNavigation
  },

  data() {
    return {
      loading: true,
      subfolders: [],
      company: "",
      companyLogos: {
        "Bosch": "bosch-logo.png",
        "Arcelik": "arcelik-logo.png",
        "LG": "lg-logo.png",
        "Hitachi": "hitachi-logo.png",
        "Dansuk": "dansuk-logo-en.png"
      }
    }
  },

  computed: {
    companyLogo() {
      return this.companyLogos[this.company] || "acme-logo.png"
    }
  },

  methods: {
    async fetchSubfolders() {
      this.loading = true
      this.company = this.$route.query.company || ""

      if (!this.company) {
        this.loading = false
        return
      }

      try {
        const db = firebase.firestore().collection("newDocs")
        const querySnapshot = await db.where("company", "==", this.company).get()
        
        const uniqueSubfolders = new Set()
        
        querySnapshot.forEach((doc) => {
          const subfolder = doc.data().subfolder
          if (subfolder) {
            uniqueSubfolders.add(subfolder)
          }
        })
        
        this.subfolders = Array.from(uniqueSubfolders).sort()
      } catch (error) {
        console.error("Error fetching subfolders:", error)
      } finally {
        this.loading = false
      }
    }
  },

  mounted() {
    this.fetchSubfolders()
  },

  watch: {
    '$route.query.company': {
      handler() {
        this.fetchSubfolders()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../styles/core/variables.scss";
  @import "../../styles/core/resets.scss";
  @import "../../styles/global/background.scss";
  @import "../../styles/global/helpers.scss";
</style>

